import {GET_VERIFYS} from "../actions/types";

const initialState = {
    items: [],
    counter: 0
}

export default function verifyReducers(state = initialState, action) {
    switch(action.type) {
        case GET_VERIFYS:
            return action.items;
        default:
            return state
    }
}
